import { SLOTS_TYPE } from '../../../utils/constants';
import {
  acceptClientAppointment,
  createAppointmentForClient,
  createAppointmentForLeadClient,
  createUnavailableAppointment,
  deleteAppointment,
  editAppointment,
  getAllVendorAppointments,
  getClientAppointments,
  getVendorOccupiedPeriod,
  rejectClientAppointment,
} from './asyncThunks';

export const getClientAppointmentsBuilder = builder => {
  builder.addCase(getClientAppointments.pending, state => {
    state.getClientAppointmentsPending = true;
  });
  builder.addCase(getClientAppointments.fulfilled, (state, action) => {
    state.clientAppointments.data = action.payload.data;

    state.getClientAppointmentsPending = false;
  });
  builder.addCase(getClientAppointments.rejected, (state, action) => {
    state.getClientAppointmentsPending = false;
  });
};

export const createAppointmentForClientBuilder = builder => {
  builder.addCase(createAppointmentForClient.pending, state => {
    state.createAppointmentForClientPending = true;
  });
  builder.addCase(createAppointmentForClient.fulfilled, (state, { payload }) => {
    const { data } = payload;

    state.clientAppointments.data = [data.clientAppointment, ...state.clientAppointments.data];
    state.vendorAppointments.data = [data.appointment, ...state.vendorAppointments.data];

    state.createAppointmentForClientPending = false;
  });
  builder.addCase(createAppointmentForClient.rejected, state => {
    state.createAppointmentForClientPending = false;
  });
};

export const getVendorOccupiedPeriodBuilder = builder => {
  builder.addCase(getVendorOccupiedPeriod.pending, state => {
    state.getVendorOccupiedPeriodPending = true;
  });
  builder.addCase(getVendorOccupiedPeriod.fulfilled, (state, { payload }) => {
    state.getVendorOccupiedPeriodPending = false;
  });
  builder.addCase(getVendorOccupiedPeriod.rejected, state => {
    state.getVendorOccupiedPeriodPending = false;
  });
};

export const editAppointmentBuilder = builder => {
  builder.addCase(editAppointment.pending, state => {
    state.editAppointmentPending = true;
  });
  builder.addCase(editAppointment.fulfilled, (state, { payload }) => {
    const { data } = payload;

    state.clientAppointments.data = state.clientAppointments.data.map(appointment => {
      if (appointment.id === data.clientAppointment.id) {
        appointment = data.clientAppointment;
      }
      return appointment;
    });

    state.vendorAppointments.data = state.vendorAppointments.data.map(appointment => {
      if (appointment.id === data.appointment.id) {
        appointment = data.appointment;
      }
      return appointment;
    });

    state.editAppointmentPending = false;
  });
  builder.addCase(editAppointment.rejected, state => {
    state.editAppointmentPending = false;
  });
};

export const getVendorAppointmentsBuilder = builder => {
  builder.addCase(getAllVendorAppointments.pending, state => {
    state.getVendorAppointmentsPending = true;
  });
  builder.addCase(getAllVendorAppointments.fulfilled, (state, { payload }) => {
    const { data } = payload;
    let formattedData = data.map(event => {
      if (event.type === SLOTS_TYPE.UNAVAILABLE) {
        event = { ...event, color: '#E8E8E8' };
      }
      return event;
    });
    state.vendorAppointments.data = formattedData;

    state.getVendorAppointmentsPending = false;
  });
  builder.addCase(getAllVendorAppointments.rejected, state => {
    state.getVendorAppointmentsPending = false;
  });
};

export const createUnavailableAppointmentBuilder = builder => {
  builder.addCase(createUnavailableAppointment.pending, state => {
    state.createUnavailableAppointmentPending = true;
  });
  builder.addCase(createUnavailableAppointment.fulfilled, (state, { payload }) => {
    const { data } = payload;
    let formattedData = { ...data, color: '#E8E8E8' };
    state.vendorAppointments.data = [formattedData, ...state.vendorAppointments.data];

    state.createUnavailableAppointmentPending = false;
  });
  builder.addCase(createUnavailableAppointment.rejected, state => {
    state.createUnavailableAppointmentPending = false;
  });
};

export const acceptClientAppointmentBuilder = builder => {
  builder.addCase(acceptClientAppointment.pending, state => {
    state.acceptClientAppointmentPending = true;
  });
  builder.addCase(acceptClientAppointment.fulfilled, (state, { payload }) => {
    state.acceptClientAppointmentPending = false;
  });
  builder.addCase(acceptClientAppointment.rejected, state => {
    state.acceptClientAppointmentPending = false;
  });
};

export const rejectClientAppointmentBuilder = builder => {
  builder.addCase(rejectClientAppointment.pending, state => {
    state.rejectClientAppointmentPending = true;
  });
  builder.addCase(rejectClientAppointment.fulfilled, (state, { payload }) => {
    state.rejectClientAppointmentPending = false;
  });
  builder.addCase(rejectClientAppointment.rejected, state => {
    state.rejectClientAppointmentPending = false;
  });
};

export const deleteAppointmentBuilder = builder => {
  builder.addCase(deleteAppointment.pending, state => {
    state.deleteAppointmentPending = true;
  });
  builder.addCase(deleteAppointment.fulfilled, (state, { payload }) => {
    const { id } = payload;
    state.clientAppointments.data = state.clientAppointments.data.filter(app => app.id !== id);
    state.vendorAppointments.data = state.vendorAppointments.data.filter(appointment => appointment.id !== id);

    state.deleteAppointmentPending = false;
  });
  builder.addCase(deleteAppointment.rejected, state => {
    state.deleteAppointmentPending = false;
  });
};

export const createAppointmentForLeadClientBuilder = builder => {
  builder.addCase(createAppointmentForLeadClient.pending, state => {
    state.createAppointmentForLeadClientPending = true;
  });
  builder.addCase(createAppointmentForLeadClient.fulfilled, (state, { payload }) => {
    const { data } = payload;

    state.vendorAppointments.data = [data, ...state.vendorAppointments.data];
    state.createAppointmentForLeadClientPending = false;
  });
  builder.addCase(createAppointmentForLeadClient.rejected, state => {
    state.createAppointmentForLeadClientPending = false;
  });
};
